<!-- start banner Area -->
<section class="page-back">
  <section class="top-banner mb-5">
    <div class="top-banner-img" style="">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 style="padding: 30px 0px 0px 0px !important;"> Accueil {{ portailName }}</h1>
            <p style="padding: 0px 0px 30px 0px;">
              <a [routerLink]="['/accueil', 'entreprise']" style="color: #ff5a00 !important"
                *ngIf="typeUser == 'entreprise' "> Accueil {{ portailName }} </a>
              <a [routerLink]="['/accueil', 'candidat']" style="color: #ff5a00 !important; "
                *ngIf="typeUser == 'candidat' "> Accueil {{ portailName }} </a>
              <a [routerLink]="['/accueil', 'consultant']" style="color: #ff5a00 !important"
                *ngIf="typeUser == 'consultant' "> Accueil {{ portailName }} </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End banner Area -->

  <!-- Start service Area -->
  <section class="service-area section-gap" id="service">
    <div class="container">
      <!-- Actions for candidats -->
      <div *ngIf="typeUser == 'candidat'" class="mb-4">
        <section class="">
          <div class="row">
            <div class="col-md-8 ">
              <div class="card"
                style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);border-radius: 15px;">
                <div class="card-header">
                  <h4 class="information">Identifiants et données</h4>
                </div>
                <div class="card-body">
                  <div class="row  justify-content-center">
                    <div class="col-lg-4">
                      <img src="assets/img/avatar.jpg" width="100" alt="">
                    </div>
                    <div class="col-lg-8">
                      <p><strong class="information">Nom & Prénoms:</strong> {{ candidates.getLastName() }} {{
                        candidates.getFirstName() }}</p>
                      <!-- <p><strong class="information">Date de naissance:</strong> {{ candidates.getDateBirth() }}</p> -->
                      <p><strong class="information">Email:</strong> {{ candidates.getEmail() }}</p>
                      <p><strong class="information">Téléphone:</strong> {{ candidates.getPhone1() }}</p>
                      <p><strong class="information">Type de profil:</strong> Emploi, Intérrim</p>
                      <!-- <p><strong class="information">Adresse:</strong> {{ candidates.getCity() }}, {{
                        candidates.getCountry() }}</p> -->
                    </div>

                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-4 ">
              <div class="card"
                style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);border-radius: 15px;">
                <div class="card-header">
                  <h4 class="information">Profil & CV</h4>
                </div>

                <div class="card-body">
                  <p>Profil complèté à {{ totalFillingRate }} %</p>
                  <div class="progress">
                    <div style="color: white !important;"
                      [ngClass]="{'progress-bar bg-danger text-white': totalFillingRate < 50, 'progress-bar bg-warning text-dark' : totalFillingRate < 100, 'progress-bar bg-success text-center text-white' : totalFillingRate === 100 }"
                      role="progressbar"
                      [ngStyle]="{'width': totalFillingRate + '%', 'text-align': 'center','color':'white'}"
                      aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">{{ totalFillingRate }}%</div>
                  </div>
                  <div class="mt-4">
                    <p *ngIf=" totalFillingRate < 100">Votre profil n'est pas complet à 100%</p>
                    <p *ngIf=" totalFillingRate == 100">Votre profil est complet à 100%</p>
                    <p *ngIf=" totalFillingRate < 100">Complètez votre profil <a href="/candidat-infos"
                        style="font-size: 18px !important; color: #ff5a00;">ici</a> </p>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="row mb-5 mt-5">
            <div class="col-md-8 ">
              <div class="card pr-5 pl-5"
                style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
                <div class="card-body" id="depot-cv">
                  <h3 class="mt-5 mb-5" style="text-align: center; font-weight: bold;">Profile & CV </h3>
                  <div class="row  justify-content-center">

                    <div class="col-lg-3">
                      <img src="assets/img/avatar.png" width="100" alt="">
                    </div>
                    <div class="col-lg-6">
                      <p class="information"><strong>Nom & Prénoms:</strong> {{ candidates.getLastName() }} {{
                        candidates.getFirstName() }}</p>
                      <p class="information"><strong>Date de naissance:</strong> {{ candidates.getDateBirth() }}</p>
                      <p class="information"><strong>Email:</strong> {{ candidates.getEmail() }}</p>
                      <p class="information"><strong>Téléphone:</strong> {{ candidates.getPhone1() }}</p>
                      <p class="information"><strong>Type de profil:</strong> Emploi, Intérrim</p>
                      <p class="information"><strong>Adresse:</strong> {{ candidates.getCity() }}, {{
                        candidates.getCountry() }}</p>
                    </div>
                    <div class="col-lg-3" *ngIf="totalFillingRate > 20">

                      <a class="btn btn-submit" href="/candidat-infos" target="_blank">Modifier les informations</a>

                    </div>
                    <div class="col-lg-3" *ngIf="totalFillingRate <= 20">

                      <a class="btn btn-submit" routerLink="/depot-cv">Dépôt de CV</a>

                    </div>

                  </div>
                  <div class="row">
                    <div class="col-lg-5"></div>
                    <div class="col-lg-2"></div>
                    <div class="col-lg-5"></div>
                  </div>

                  <div *ngIf="totalFillingRate > 20">
                    <div class="row mt-4">
                      <h3 class="mb-5">Complétez votre profil, pour plus de détails voir ci-dessous :</h3>
                      <div class=" col-lg-5">
                        <div class="card shodow">
                          <div class="card-body link-parent">
                            <a routerlink="/job-list" class="customize-link2" ng-reflect-router-link="/candidat-infos"
                              href="/candidat-infos">
                              Informatios personnelles</a>
                            <a routerlink="/compte-candidat" class="customize-link2"
                              ng-reflect-router-link="/candidat-trainings" href="/candidat-trainings"> Formations et
                              Diplômes</a>
                            <a routerlink="/mes-sauvegardes" class="customize-link2"
                              ng-reflect-router-link="/candidat-experiences" href="/candidat-experiences"> Expériences
                              professionnelles</a>
                          </div>
                        </div>
                      </div>
                      <div class="  col-lg-2">

                      </div>
                      <div class=" col-lg-5">
                        <div class="card shodow">
                          <div class="card-body link-parent">
                            <a routerlink="/compte-candidat" class="customize-link2"
                              ng-reflect-router-link="/candidat-trainings" href="/candidat-certificates"> Formations
                              Qualifiante</a>
                            <a routerlink="/mes-sauvegardes" class="customize-link2"
                              ng-reflect-router-link="/candidat-experiences" href="/candidat-software"> Connaissances
                              Informatique</a>
                            <a routerlink="/mes-sauvegardes" class="customize-link2"
                              ng-reflect-router-link="/candidat-experiences" href="/candidat-languages"> Connaissances
                              lingustique</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class=" col-lg-4">
                        <div class="card shodow">
                          <div class="card-body">
                            <a [href]="candidates.getCvPath()" target="_blank" class="btn btn-secondary mb-3 infos-btn"
                              *ngIf="candidates.getCvPath() != null">Afficher
                              CV</a>

                            <a class="btn btn-secondary infos-btn" href="/candidat-infos">Remplacer CV </a>
                          </div>
                        </div>
                      </div>
                      <div class="  col-lg-4">
                        <div class="card shodow">
                          <div class="card-body">
                            <a class="btn btn-secondary mb-3 infos-btn" routerLink="job-list">Offres d'emploi </a> <br>
                            <a class="btn btn-secondary infos-btn" href="cv/modele-cv-emploi" target="_blank">Modèles de
                              CV</a>
                          </div>
                        </div>
                      </div>
                      <div class=" col-lg-4">
                        <div class="card shodow">
                          <div class="card-body">
                            <a class="btn btn-secondary mb-3 infos-btn" href="">CHANGER LE MOT DE PASSE </a> <br>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div class="row mt-4 card ">
                    <div class="card-body">
                      <div class="col-md-12 mb-5">
                        <h4 class="mb-3">Offres d'emploi sauvegardées</h4>

                        <div class="col-lg-12 post-list" style="margin-left: -15px;">
                          <p *ngIf="jobList.length == 0"> Aucune offre d'emploi trouvée. </p>
                          <div class="single-post d-flex flex-row w-100 height-fixe" *ngFor="let job of jobList">
                            <div class="thumb mr-4">
                              <img src="{{baseURL +job.getCompany()['logo']}}" alt="" class="company-logo">
                            </div>
                            <div class="details" style="width: 100%;">
                              <div class="title d-flex flex-row justify-content-between">
                                <div class="titles" style="font-weight: bold;">
                                  <a href="#">
                                    <h5>{{ functionsService.wordWrap(job.getLibelle(), 50) }}</h5>
                                  </a>
                                  <h6>{{ job.getCompany()['acronym'] }}</h6>
                                </div>
                              </div>
                              <!-- <p>
                                La société {{ job.getCompany()['acronym'] }} recherche un profil comme tel :
                              </p>
                              <div class="address"><span class="lnr lnr-license"></span> <span
                                  *ngFor="let training of job.getJobsTrainings()">
                                  {{ training.getLevelOfStudy() }} en {{ training.getTraining()['libelle'] }} | </span>
                              </div>
                              <div class="address"><span class="lnr lnr-calendar-full"></span> {{
                                job.getYearOfExperience() }} <span
                                  *ngIf="job.getYearOfExperience() != 'Sans expérience'">d'expériences</span>, <span
                                  class="lnr lnr-map-marker"></span> {{ job.getCity() }}, {{ job.getCountry() }} </div> -->
                              <div class="address d-flex my-4">
                                <a [routerLink]="['/offres-emploi', job.getId()]">
                                  <span class="mr-2 btn btn-success a-btn-slide-text">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                      class="bi bi-display" viewBox="0 0 16 16">
                                      <path
                                        d="M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z" />
                                    </svg>
                                  </span>
                                </a>
                                <span class="mr-2 btn btn-danger a-btn-slide-text"
                                  (click)="removeBackupJob(job.getId())">
                                  <span class="glyphicon glyphicon-remove" aria-hidden="true"><svg
                                      xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                      class="bi bi-trash" viewBox="0 0 16 16">
                                      <path
                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                      <path fill-rule="evenodd"
                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                    </svg></span>
                                </span>

                                <a [routerLink]="['/postuler', job.getId()]">
                                  <span class="mr-2 btn btn-primary a-btn-slide-text"><svg
                                      xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                      class="bi bi-send" viewBox="0 0 16 16">
                                      <path
                                        d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                                    </svg></span>
                                </a>


                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row mt-4 card shodow">
                    <div class="card-body">
                      <h3>Mes candidatures</h3>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <app-articles></app-articles>
            </div>
          </div>
        </section>

        <section
          style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
          <div class="container">
            <app-autresites></app-autresites>
          </div>
        </section>



      </div>

      <!-- Actions for consultants -->
      <div class="row d-flex justify-content-center" *ngIf="typeUser == 'consultant'">
        <div class="col-md-6 pb-40 form-area">
          <div class="row text-center">
            <div class="col-lg-6 mb-4">
              <a routerLink="/compte-consultant"><button class="btn-portail-start">CV thèque</button></a>
            </div>
            <div class="col-lg-6 mb-4">
              <a role="link" aria-disabled="true"><button class="btn-portail-start">Souscrire à un forfait</button></a>
            </div>
          </div>
        </div>
      </div>

      <!-- Actions for entreprises -->
      <div class="row d-flex justify-content-center" *ngIf="typeUser == 'entreprise'">
        <div class="col-md-6 pb-40 form-area">
          <div class="row text-center">
            <div class="col-lg-6 mb-4">
              <a routerLink="/"><button class="btn-portail-start">Offres d'emploi</button></a>
            </div>
            <div class="col-lg-6 mb-4">
              <a routerLink="/mes-offres-emploi"><button class="btn-portail-start">Mes offres d'emploi</button></a>
            </div>
            <div class="col-lg-6 mb-4">
              <a routerLink="/publier-offre-emploi"><button class="btn-portail-start">Poster une offre
                  d'emploi</button></a>
            </div>
            <div class="col-lg-6 mb-4">
              <a routerLink="/tous-les-candidats"><button class="btn-portail-start">Consulter CV thèque</button></a>
            </div>
            <div class="col-lg-6 mb-4">
              <a routerLink="/compte-entreprise"><button class="btn-portail-start">Editer mes informations</button></a>
            </div>
            <div class="col-lg-6 mb-4">
              <a role="link" aria-disabled="true"><button class="btn-portail-start">Souscrire à un forfait</button></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
<!-- End service Area -->